export default {
	/**
	 * Determine if the ferment does not have enough data.
	 *
	 * @param object ferment
	 *
	 * @return bool
	 */
	fermentNotEnoughData(ferment) {
		// If the ferment has no daily data then we are unable to simulate OR the ferment
		// does not have a desired duration.
		if (! ferment.dailyData.data || ! ferment.duration) {
			return true;
		}

		// If the ferment has less than 4 points of actual entered data, this means we
		// need at least 4 baume entries.
		let baumeCount = 0;

		for (let i = 0; i < ferment.dailyData.data.length; ++i) {
			if (ferment.dailyData.data[i].baume) {
				baumeCount++;
			}
		}

		if (baumeCount < 4) {
			return true;
		}

		// If the ferment does not have a volume then we are unable to simulate.
		if (! ferment.volume) {
			return true;
		}

		return false;
	}
}



// WEBPACK FOOTER //
// ./src/utils/fermenters.js